export default __webpack_public_path__ + "static/media/nh-vid-1.96ade133.mp4";